// AUTO-GENERATED - Do not edit manually
// Run: node scripts/generate-contentful-defaults.mjs --locale=zh-CN to regenerate

export const benefitsCommuter = {
  benefits_section_commuter: {
    contentful_name: '[DEFAULT] Benefits Section - Commuter',
    contribution_limit: 340,
    fsa: '您可以使用通勤FSA账户,该账户允许您预留税前资金来支付通勤费用。',
    more_info: '查看您的计划详情以获取更多信息。',
    location: '前往{loc}以访问您的通勤储蓄。',
    parking_and_transit:
      '您每月最多可以在停车上花费{limit},另外每月可以在公共交通(如火车票和共享出行)上花费{limit}。',
    parking_only: '您每月最多可以在停车上花费{limit}。请注意,您的通勤福利不包括公共交通。',
    transit_only:
      '您每月最多可在公共交通上花费 {limit},例如火车票和拼车费用。请注意,您的通勤福利不包括停车费。',
  },
};
